import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import { useProjectByCategory } from '../api/getProjectsByCategory'

type ProjectsProps = {
  id: string
}
export const Projects = ({ id }: ProjectsProps) => {
  const projects = useProjectByCategory(id)
  const navigate = useNavigate()
  if (projects.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }

  if (!projects.data) return null
  return (
    <div className="flex w-full flex-col flex-wrap gap-y-[12px] lg:flex-row">
      {projects.data.map(({ _id, coverPhoto, title }, index) => (
        <div
          key={_id}
          onClick={() => navigate(`./${_id}`)}
          className={twMerge(
            `relative cursor-pointer aspect-[16/10] size-full lg:overflow-hidden group shrink-0 lg:w-[calc(50%-12px)]`,
            index % 2 === 0 ? 'mr-[24px]' : ''
          )}
        >
          <span className="absolute left-1/2 top-1/2 z-30 -translate-x-1/2 -translate-y-1/2 select-none text-center font-nunito text-[16px] font-bold leading-[21.82px] text-[#FFFFFF] opacity-0 lg:transition-all lg:duration-500 lg:group-hover:opacity-100">
            {title}
          </span>
          <div className="absolute z-10 size-full bg-[rgba(0,0,0,0.2)] lg:bg-[rgba(0,0,0,0.4)] lg:opacity-0 lg:transition-all lg:duration-500 lg:group-hover:opacity-100"></div>
          <img
            className="relative z-0 size-full object-cover lg:transition-all lg:duration-500 lg:group-hover:scale-110"
            src={coverPhoto.url}
          />
          <span className="absolute bottom-0 z-20 rounded-tr-[8px] bg-[#D9C7B0] px-[10px] py-[5px] font-nunito text-[12px] leading-[16.37px] text-[#333333] [font-weight:500] md:text-[16px] md:leading-[25px] lg:hidden">
            {title}
          </span>
        </div>
      ))}
    </div>
  )
}
